import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
    ApiRequestService,
    LogService,
    UseCase
} from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { AddProductRequest } from './add-product.request';

@Injectable({ providedIn: 'root' })
export class AddProductUseCase extends UseCase<AddProductRequest, Observable<HttpResponse<unknown>>> {

    private _apiRequestService = inject(ApiRequestService);
    private _storeBaseUrl = inject<string>('STORE_BACKEND_URL' as never);
    private _addProductUrl = '/admin/addproduct';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(request: AddProductRequest): Observable<HttpResponse<unknown>> | void {
        return this._apiRequestService.sendRequest<AddProductRequest, HttpResponse<unknown>>(
            this._storeBaseUrl,
            request,
            true,
            this._addProductUrl
        );
    }
}